import { useTranslation } from "react-i18next"
import type { PeerProfile } from "../../types"
import { PeerAvatar } from "../PeerAvatar"
import s from "./TypingIndicator.module.scss"

type TypingIndicatorProps = {
  /** Who is typing. */
  author: PeerProfile
  /** Groups only: a direct conversation has one person who could be typing. */
  showsName?: boolean
}

/**
 * Someone is writing a reply. Laid out like a message from them, so it sits
 * where their next bubble will land: after the last message in `Thread`.
 */
export function TypingIndicator({
  author,
  showsName = false,
}: TypingIndicatorProps) {
  const { t } = useTranslation()
  const label = String(t("chat.TYPING", { name: author.displayName }))

  return (
    <div className={s.typing}>
      <PeerAvatar {...author} size="small" />

      <div className={s.typing__body}>
        {showsName && (
          <span className={s.typing__name} aria-hidden="true">
            {label}
          </span>
        )}
        <div className={s.typing__bubble} role="status" aria-label={label}>
          <span className={s.typing__dot} />
          <span className={s.typing__dot} />
          <span className={s.typing__dot} />
        </div>
      </div>
    </div>
  )
}
